<app-cookie-consent-banner></app-cookie-consent-banner>
<app-mobile-app-prompt></app-mobile-app-prompt>
<!-- Main view/routes wrapper-->
<router-outlet></router-outlet>
